/* Wrapper that applies the .uro-app-screen scope class and imports CSS */
import '../../styles/app-screens.css';

export default function AppScreenWrapper({ children }) {
  return (
    <div className="uro-app-screen">
      {children}
    </div>
  );
}
